function ClearIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      stroke="#363837"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6998 1.35355L0.697403 13.3536"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.702772 1.35355L12.7052 13.3536"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ClearIcon;
